import { tryParse } from "@gotti/core";

export async function httpPostAsync(url, token, request) {
    return new Promise((resolve, reject) => {
        const http = new XMLHttpRequest();
        http.open('POST', url, true);
        http.setRequestHeader('Content-Type', 'application/json');
        if(token) {
            http.setRequestHeader('authorization', token);
        }
    
        http.onreadystatechange = function() {//Call a function when the state changes.
            if(http.readyState == 4) {
                const resOrRej = http.status === 200 ? resolve : reject;
                resOrRej(tryParse(http.responseText));
            }
        };
        http.send(JSON.stringify(request));
    });
}

export async function httpGetAsync(url, token) {
    return new Promise((resolve, reject) => {
        const http = new XMLHttpRequest();
        http.open("GET", url, true); // true for asynchronous
    
        http.responseType = 'text';
        http.setRequestHeader('Authorization', token);
    
        http.onreadystatechange = function() {
            if (http.readyState == 4){
                const resOrRej = http.status === 200 ? resolve : reject;
                resOrRej(tryParse(http.responseText));
            }
        };
        http.send(null);
    });
}


/**
 * Helper module to load webrtc-adapter only once and share it across files
 */

// Create a promise that resolves when adapter is loaded
let adapterLoaded: Promise<unknown> = Promise.resolve(); // Default to resolved for non-browser

if (typeof window !== 'undefined') {
  adapterLoaded = import('webrtc-adapter')
    .catch(err => {
      console.warn('Optional dependency webrtc-adapter could not be loaded:', err.message);
      // Still resolve the promise so code continues
    });
}

/**
 * Returns a promise that resolves when webrtc-adapter is loaded
 * This will only attempt to load the adapter once, even if called from multiple files
 */
export function ensureWRTCAdapterLoadFinished(): Promise<unknown> {
  return adapterLoaded;
}